import { useTranslation } from 'react-i18next';

/**
 * Two causes land on this route, and they are different answers to the user
 * (ADR-0001 Amendment 4; `.claude/rules` — a failure must never look like an
 * absence, and causes must be distinguishable on screen):
 *
 *  - `not_permitted` — the caller's ROLE lacks the permission. Their employer
 *    may well own the product; the fix is their own administrator.
 *  - `not_entitled` — the TENANT has not booked the area. The fix is to talk
 *    to us.
 *
 * Telling a staff member to contact sales about something their company
 * already pays for, or telling an owner their role is insufficient when it is
 * the subscription that is missing, both send the reader to the wrong place.
 *
 * `not_permitted` is the default because it fits every gate in `App.tsx` that
 * is a permission check — which is all of them except access management, whose
 * unentitled case has a page of its own (`AccessManagementUpsell`).
 */
export default function Unauthorized({
    cause = 'not_permitted',
}: {
    cause?: 'not_permitted' | 'not_entitled';
}) {
    const { t } = useTranslation();

    return (
        <div className={'flex m-auto items-center h-[90vh] justify-center px-6'}>
            <p className={'max-w-xl text-center text-base text-foreground'}>
                {t(`common.unauthorized_${cause}`)}
            </p>
        </div>
    );
}
